import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import WorldTreeView from '../shared/views/worldTree/worldTreeView';

const initialStateWorldTree = window.__INITIAL_STATE_WORLD_TREE__;
delete window.__INITIAL_STATE_WORLD_TREE__;
const worldTreeRoot = document.getElementById('world-tree-view');

if (worldTreeRoot) {
  hydrateRoot(
    worldTreeRoot,
    <Globals siteId={initialStateWorldTree.siteId}>
      <WorldTreeView
        regions={initialStateWorldTree.regions}
        selectedId={initialStateWorldTree.selectedId}
      />
    </Globals>, 
  );
}
